import styled, { keyframes } from "styled-components";

const skeletonPulse = keyframes`
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
`;

export const StyledSlotsPage = styled.div`
  .slot-page-shell {
    display: flex;
    flex-direction: column;
    gap: 22px;
    width: 100%;
    padding: 8px 0 46px;
  }

  .slot-search-row {
    display: flex;
    width: 100%;
  }

  .slot-search-box {
    position: relative;
    display: flex;
    align-items: center;
    width: min(100%, 1100px);
    height: 48px;
    border-radius: 8px;
    border: 1px solid var(--crypto-border);
    background: rgba(7, 19, 27, 0.58);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);
    transition: border-color 0.18s ease, box-shadow 0.18s ease;
  }

  .slot-search-box:focus-within {
    border-color: rgba(89, 244, 119, 0.7);
    box-shadow: 0 0 0 3px rgba(89, 244, 119, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.04);
  }

  .search-icon {
    position: relative;
    flex: 0 0 auto;
    width: 17px;
    height: 17px;
    margin-left: 18px;
    border: 2px solid #9cb2c4;
    border-radius: 50%;
    opacity: 0.9;
  }

  .search-icon::after {
    content: "";
    position: absolute;
    width: 8px;
    height: 2px;
    right: -6px;
    bottom: -3px;
    border-radius: 999px;
    background: #9cb2c4;
    transform: rotate(45deg);
  }

  .slot-search-box input {
    width: 100%;
    min-width: 0;
    height: 100%;
    border: 0;
    outline: 0;
    color: #e9f2f5;
    background: transparent;
    padding: 0 18px 0 15px;
    font-size: 15px;
    font-weight: 500;
  }

  .slot-search-box input::placeholder {
    color: #86a0b4;
  }

  .slot-toolbar,
  .slot-result-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }

  .slot-toolbar-title {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
    color: #d9e5ef;
  }

  .slot-toolbar-title strong {
    color: #ffffff;
    font-size: 15px;
    font-weight: 800;
  }

  .slot-toolbar-title em {
    color: var(--crypto-green);
    font-size: 13px;
    font-style: normal;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .filter-icon {
    position: relative;
    width: 18px;
    height: 18px;
    color: #a9bece;
  }

  .filter-icon::before {
    content: "";
    position: absolute;
    inset: 1px 2px 0;
    clip-path: polygon(0 0, 100% 0, 64% 46%, 64% 100%, 38% 100%, 38% 46%);
    background: currentColor;
  }

  .slot-sort-control {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #a8b8c7;
    font-size: 13px;
    font-weight: 700;
  }

  .slot-sort-control select {
    height: 38px;
    min-width: 92px;
    border: 0;
    border-radius: 8px;
    color: #ffffff;
    background: var(--crypto-surface-raised);
    padding: 0 12px;
    font-size: 13px;
    font-weight: 700;
    outline: 0;
  }

  .slot-provider-strip {
    display: flex;
    align-items: center;
    gap: 8px;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 2px 2px 8px;
    scrollbar-width: thin;
    scrollbar-color: rgba(139, 177, 205, 0.26) transparent;
    overscroll-behavior-inline: contain;
    -webkit-overflow-scrolling: touch;
    touch-action: pan-x;
    user-select: none;
  }

  .slot-provider-strip::-webkit-scrollbar {
    height: 4px;
  }

  .slot-provider-strip::-webkit-scrollbar-track {
    background: transparent;
  }

  .slot-provider-strip::-webkit-scrollbar-thumb {
    border-radius: 999px;
    background: rgba(139, 177, 205, 0.22);
  }

  .slot-provider-strip:hover::-webkit-scrollbar-thumb {
    background: rgba(139, 177, 205, 0.38);
  }

  .slot-provider-strip.is-dragging {
    cursor: grabbing;
  }

  .slot-provider-card {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: auto;
    min-width: 82px;
    max-width: 180px;
    height: 36px;
    border: 1px solid var(--crypto-border-soft);
    border-radius: 8px;
    color: #aeb9c8;
    padding: 0 14px;
    background: rgba(8, 22, 29, 0.72);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.025);
    cursor: pointer;
    transition:
      color 0.16s ease,
      border-color 0.18s ease,
      background 0.18s ease,
      box-shadow 0.18s ease;
  }

  .slot-provider-card:hover {
    color: #eef5f3;
    border-color: rgba(139, 177, 205, 0.28);
    background: rgba(13, 31, 40, 0.86);
  }

  .slot-provider-card.is-selected {
    color: #59f477;
    border-color: rgba(89, 244, 119, 0.42);
    background: rgba(89, 244, 119, 0.08);
    box-shadow:
      inset 0 0 0 1px rgba(89, 244, 119, 0.06),
      inset 0 1px 0 rgba(255, 255, 255, 0.035);
  }

  .slot-provider-card span {
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 13px;
    line-height: 1;
    font-weight: 700;
    letter-spacing: 0;
  }

  .provider-skeleton,
  .slot-game-skeleton {
    pointer-events: none;
    cursor: default;
    background: linear-gradient(90deg, #122d38 0%, #1f404c 48%, #122d38 100%);
    background-size: 220% 100%;
    animation: ${skeletonPulse} 1.2s ease-in-out infinite;
  }

  .slot-result-head h1 {
    margin: 0;
    color: #ffffff;
    font-size: 20px;
    line-height: 1.2;
    font-weight: 900;
  }

  .slot-result-head span {
    display: inline-flex;
    margin-top: 5px;
    color: #8fa1b0;
    font-size: 13px;
    font-weight: 500;
  }

  .slot-result-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    min-width: 0;
  }

  .slot-game-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(138px, 1fr));
    gap: 22px 12px;
    align-items: start;
  }

  .slot-game-card-shell {
    position: relative;
    display: block;
    min-width: 0;
  }

  .slot-game-card {
    display: flex;
    flex-direction: column;
    gap: 7px;
    width: 100%;
    min-width: 0;
    border: 0;
    background: transparent;
    padding: 0;
    color: inherit;
    text-align: left;
    cursor: pointer;
  }

  .favorite-toggle {
    position: absolute;
    z-index: 8;
    top: 8px;
    right: 8px;
    width: 31px;
    height: 31px;
    border: 1px solid rgba(166, 196, 213, 0.22);
    border-radius: 50%;
    background: rgba(6, 18, 24, 0.78);
    color: rgba(224, 236, 244, 0.9);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.28);
    transition: transform 0.18s ease, background 0.18s ease, color 0.18s ease,
      border-color 0.18s ease, box-shadow 0.18s ease;
  }

  .favorite-toggle span {
    display: block;
    font-size: 17px;
    line-height: 1;
    transform: translateY(-1px);
  }

  .favorite-toggle:hover,
  .favorite-toggle:focus-visible {
    color: #ffffff;
    border-color: rgba(89, 244, 119, 0.48);
    background: rgba(18, 66, 39, 0.92);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.34), 0 0 14px rgba(89, 244, 119, 0.2);
    transform: translateY(-1px) scale(1.04);
    outline: 0;
  }

  .favorite-toggle.is-active {
    color: #07130c;
    border-color: rgba(89, 244, 119, 0.7);
    background: linear-gradient(135deg, #7cff91, #28d765);
  }

  .slot-game-image {
    position: relative;
    display: block;
    aspect-ratio: 5 / 7;
    width: 100%;
    overflow: hidden;
    border-radius: 8px;
    background:
      linear-gradient(150deg, rgba(89, 244, 119, 0.1), rgba(12, 32, 40, 0.94)),
      var(--crypto-surface-2);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.22);
    transform: translateY(0);
    transition: transform 0.22s ease, box-shadow 0.22s ease;
  }

  .slot-game-card:hover .slot-game-image,
  .slot-game-card:focus-visible .slot-game-image {
    transform: translateY(-7px);
    box-shadow: 0 18px 32px rgba(0, 0, 0, 0.34), 0 0 20px rgba(89, 244, 119, 0.1);
  }

  .slot-game-image img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    transition: filter 0.24s ease, transform 0.24s ease;
  }

  .slot-game-card:hover .slot-game-image img,
  .slot-game-card:focus-visible .slot-game-image img {
    filter: blur(2px) brightness(0.52) saturate(1.08);
    transform: scale(1.06);
  }

  .slot-game-image::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, transparent 36%, rgba(6, 8, 13, 0.88) 100%);
    pointer-events: none;
  }

  .slot-game-title {
    position: absolute;
    left: 10px;
    right: 10px;
    bottom: 13px;
    z-index: 2;
    color: #ffffff;
    font-family: var(--crypto-display-font);
    font-size: 14px;
    line-height: 1.16;
    font-weight: 700;
    text-align: center;
    text-shadow: 0 2px 9px rgba(0, 0, 0, 0.88);
    word-break: keep-all;
    overflow-wrap: anywhere;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    transition: opacity 0.18s ease, transform 0.18s ease;
  }

  .slot-game-overlay {
    position: absolute;
    inset: 0;
    z-index: 3;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
    padding: 18px 12px;
    text-align: center;
    background: rgba(4, 8, 11, 0.2);
    opacity: 0;
    transform: translateY(10px);
    transition: opacity 0.2s ease, transform 0.2s ease;
  }

  .slot-game-card:hover .slot-game-overlay,
  .slot-game-card:focus-visible .slot-game-overlay {
    opacity: 1;
    transform: translateY(0);
  }

  .slot-game-card:hover .slot-game-title,
  .slot-game-card:focus-visible .slot-game-title {
    opacity: 0;
    transform: translateY(8px);
  }

  .slot-play-button {
    width: 58px;
    height: 58px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #59f477, #16b857);
    box-shadow: 0 14px 28px rgba(22, 184, 87, 0.4), 0 0 24px rgba(89, 244, 119, 0.2),
      inset 0 1px 0 rgba(255, 255, 255, 0.44);
  }

  .slot-play-button::before {
    content: "";
    width: 0;
    height: 0;
    margin-left: 4px;
    border-top: 11px solid transparent;
    border-bottom: 11px solid transparent;
    border-left: 16px solid #ffffff;
    filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2));
  }

  .slot-game-overlay strong {
    color: #ffffff;
    font-family: var(--crypto-display-font);
    font-size: 17px;
    line-height: 1.16;
    font-weight: 700;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.78);
    word-break: keep-all;
    overflow-wrap: anywhere;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .slot-game-fallback {
    position: absolute;
    inset: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    color: #ffffff;
    font-size: 17px;
    line-height: 1.18;
    font-weight: 900;
    text-align: center;
  }

  .slot-game-meta {
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
    color: #9dafbf;
    font-size: 12px;
    line-height: 1.2;
    font-weight: 600;
  }

  .live-dot {
    width: 6px;
    height: 6px;
    flex: 0 0 auto;
    border-radius: 50%;
    background: var(--crypto-green);
    box-shadow: 0 0 8px rgba(89, 244, 119, 0.56);
  }

  .slot-game-skeleton {
    display: block;
    aspect-ratio: 5 / 7;
    border-radius: 8px;
  }

  .slot-state {
    min-height: 110px;
    border: 1px solid rgba(139, 177, 205, 0.17);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #a8b6c5;
    background: rgba(166, 196, 213, 0.045);
    font-size: 14px;
  }

  .slot-state.error {
    color: #ff8585;
    border-color: rgba(255, 133, 133, 0.2);
    background: rgba(255, 70, 70, 0.04);
  }

  .slot-load-more {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 56px;
    color: #8fa1b0;
    font-size: 13px;
    font-weight: 700;
  }

  .slot-load-more button {
    height: 40px;
    min-width: 132px;
    border: 0;
    border-radius: 999px;
    color: #07130c;
    background: linear-gradient(135deg, #7cff91, #28d765 52%, #18a94b);
    box-shadow: 0 12px 24px rgba(22, 184, 87, 0.25), inset 0 1px 0 rgba(255, 255, 255, 0.42);
    font-size: 13px;
    font-weight: 900;
    cursor: pointer;
  }

  .slot-load-more button:disabled {
    opacity: 0.7;
    cursor: wait;
  }

  @media (min-width: 768px) {
    .slot-game-grid {
      grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
      gap: 24px 14px;
    }
  }

  @media (min-width: 1440px) {
    .slot-game-grid {
      grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    }
  }

  @media (max-width: 700px) {
    .slot-page-shell {
      gap: 18px;
      padding-bottom: 32px;
    }

    .slot-toolbar,
    .slot-result-head {
      align-items: flex-start;
      flex-direction: column;
    }

    .slot-result-actions {
      width: 100%;
      justify-content: stretch;
    }

    .slot-sort-control {
      width: 100%;
      justify-content: space-between;
    }

    .slot-provider-strip {
      gap: 7px;
      padding-bottom: 7px;
    }

    .slot-provider-card {
      min-width: 74px;
      max-width: 154px;
      height: 34px;
      padding: 0 12px;
    }

    .slot-provider-card span {
      font-size: 13px;
    }

    .slot-game-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 18px 10px;
    }
  }
`;
